import React from "react";
import IIcon from "../../interfaces/IIcon";

// icons
import FoodIcon from "./food";
import AddIcon from "./add";
import NotFoundIcon from "./notFound";
import CarIcon from "./car";
import BeerIcon from "./beer";

interface IProps extends IIcon {
    name: string;
}

const Icons = ({ name, ...rest }: IProps) => {
    const icons: { [key: string]: JSX.Element } = {
        food: <FoodIcon {...rest} />,
        notFound: <NotFoundIcon {...rest} />,
        add: <AddIcon {...rest} />,
        car: <CarIcon {...rest} />,
        beer: <BeerIcon {...rest} />,
    };

    if (!icons[name]) {
        return null;
    }

    return icons[name];
};

export default React.memo(Icons);
